/*export const createProject = (project) => {
  return (dispatch, getState, {getFirestore}) => {
    const firestore = getFirestore();
    const profile = getState().firebase.profile;
    const authorId = getState().firebase.auth.uid;
    firestore.collection('projects').add({
      ...project,
      authorFirstName: profile.firstName,
      authorLastName: profile.lastName,
      authorId: authorId,
      createdAt: new Date()
    }).then(() => {
      dispatch({ type: 'CREATE_PROJECT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'CREATE_PROJECT_ERROR' }, err);
    });
  }
};*/

export const getProjects = () => {
  return (dispatch, getState) => {
    const userID = getState().firebase.auth.uid;
  (async () => {
    
    const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/getProjects?user='+userID);
    var resp = {};
    try {
      resp = await rawResponse.json();
    } catch (err) {
      console.log(err);
    }
  
    console.log(resp);
    if (resp !== null && resp !== undefined && resp.projects !== undefined) {
      let projects = resp.projects;
      dispatch({ type: 'PROJECTS_RETRIEVED', projects});
      //this.setState({"journalLogs" : content});
    } else {
      dispatch({ type: 'PROJECTS_RETRIEVAL_ERROR', resp});
    }

  })();
  }
};

export const getLocations = (companyName, projectName) => {
  return (dispatch, getState) => {
    const userID = getState().firebase.auth.uid;
  (async () => {
    
    const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/getProjectLocationsV2?user='+userID+'&projectName='+projectName);
      
    const resp = await rawResponse.json();
  
    console.log(resp);
    if (resp !== null && resp !== undefined) {
      let projects = resp.projects;
      let locations = projects[0].locations;
      //let locationArray = [];
      //let keys =  Object.keys(locations);
      //for (var i = 0; i < locations.length; i++) {
        //locationArray.push(locations[i].hierarchy);
      //}
      dispatch({ type: 'LOCATIONS_RETRIEVED', locations: locations});
      //this.setState({"journalLogs" : content});
    } else {
      dispatch({ type: 'LOCATIONS_RETRIEVAL_ERROR', resp});
    }

  })();
  }
}

export const changeProject = (companyName, projectName) => {
  return (dispatch, getState) => {
    let project = {};
    project.projectName = projectName;
    project.companyName = companyName;
    dispatch({ type: 'PROJECT_CHANGED', project});
    
  }
}

export const getAvailableAssignments = (companyName, projectName) => {
  return (dispatch, getState) => {
    const userID = getState().firebase.auth.uid;
  (async () => {
    
    var url = new URL("https://us-central1-multilanguage-dacbe.cloudfunctions.net/getAvailableAssignments?");
    var params = {companyName:companyName, projectName:projectName};
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    const rawResponse = await fetch(url);
      
    const resp = await rawResponse.json();
  
    console.log(resp);
    if (resp !== null && resp !== undefined) {
      let assignments = resp.assignments;
      dispatch({ type: 'ASSIGNMENTS_RETRIEVED', assignments});
      //this.setState({"journalLogs" : content});
    } 

  })();
  }
};


export const setAllLocationRowsSelected = (selected) => {
  return (dispatch, getState) => {
  (async () => {
    const state = getState();

    const locationRows = state.project.locationRows;
    if (locationRows != undefined) {
      for (var i = 0; i < locationRows.length; i++) {
        locationRows[i] = selected;
      }
      dispatch({ type: 'LOCATION_ROW_SELECTED', locationRows});
      dispatch({type: 'LOCATION_ROW_SELECTALL', selected});
    }
      
      //this.setState({"journalLogs" : content});
  })();
  }
}

export const setLocationRowSelected = (locationRow, selected) => {
  return (dispatch, getState) => {
  (async () => {
    const state = getState();
    const locationRows = state.project.locationRows;
    if (locationRows != undefined) {
      locationRows[locationRow] = selected;
      dispatch({ type: 'LOCATION_ROW_SELECTED', locationRows});
    }
      
      //this.setState({"journalLogs" : content});
  })();
  }
}

export const printSelectedLocations = () => {
  return (dispatch, getState) => {
    (async () => {
      const state = getState();
      const projectName = state.project.selectedProject.projectName;
      const companyName = state.project.selectedProject.companyName;
      const filteredLocations = state.project.selectedProject.filteredLocations;
      const locationRows = state.project.locationRows;
      let locationsToPrint = new Array();
      for (var i = 0; i < locationRows.length; i++) {
        if (locationRows[i] === true) {
          let location = filteredLocations[i];
          locationsToPrint.push(location);
        }
      }


    })();
  }
}

export const openProjectModal = (open) => {
  return (dispatch, getState) => {
    (async () => {
      const state = getState();
      dispatch({type: "PROJECT_MODAL_OPEN", open});
    })();
  }
}

export const newProject = (project) => {
  return (dispatch, getState) => {
    (async () => {
      const state = getState();

      let req = {};
      req.companyName=state.project.selectedProject.companyName; //The assumption here may be incorrect.  The company state should probably be set at login and never change. 
                                                                //In fact, this API call was meant for administrative purposes.  Should probably create another API call and pass in the userID. 
      req.projectName=project.name;
      
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/newProject', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      });
      console.log(rawResponse);

      let req2 = {};
      req2.company=state.project.selectedProject.companyName; 
      req2.project=project.name;
      req2.userID=state.firebase.auth.uid;
      req2.assignmentLabel="Superintendent";
      const rawResponse2 = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/addUserToProject', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req2)
      });
      console.log(rawResponse2);

      //TODO: Error case.
      let projects = state.project.projects;
      projects.push(req);

      dispatch({type: "PROJECT_CREATED", projects});
    }
    )();
  }
}

export const updateLocationList = (filter) => {
  return (dispatch, getState) => {
    (async () => {
      const state = getState();
      const projectName = state.project.selectedProject.projectName;
      const companyName = state.project.selectedProject.companyName;
      const locations = state.project.locations;
      
      if ((filter !== undefined)) {
        const filteredLocations = new Array();
        for (var i = 0; i < locations.length; i++) {
          if (locations[i].hierarchy.startsWith(filter)) {
            filteredLocations.push(locations[i]);
          }
        }

        
        
        dispatch({ type: 'LOCATIONS_RETRIEVED', locations, filteredLocations});
      } 

    })();
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/projectActions.js